import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isDownloadModalOpen: false,
  isDownloadApkModalOpen: false,
  isDownloadApkIosModalOpen: false,
  isConfirmationPopupOpen: false,
  newLetterSuccessfullPopup: false,
};

export const modalSlice = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    openDownloadModal: (state) => {
      state.isDownloadModalOpen = true;
    },
    closeDownloadModal: (state) => {
      state.isDownloadModalOpen = false;
    },
    openDownloadApkModal: (state) => {
      state.isDownloadApkModalOpen = true;
    },
    closeDownloadApkModal: (state) => {
      state.isDownloadApkModalOpen = false;
    },
    openDownloadApkIosModal: (state) => {
      state.isDownloadApkIosModalOpen = true;
    },
    closeDownloadApkIosModal: (state) => {
      state.isDownloadApkIosModalOpen = false;
    },

    openConfirmationModal: (state) => {
      state.isConfirmationPopupOpen = true;
    },
    closeConfirmationModal: (state) => {
      state.isConfirmationPopupOpen = false;
    },

    openNewLetterSuccessfullPopup: (state) => {
      state.newLetterSuccessfullPopup = true;
    },
    closeNewLetterSuccessfullPopup: (state) => {
      state.newLetterSuccessfullPopup = false;
    }



  },
});

export const { openDownloadModal, closeDownloadModal, openDownloadApkModal, closeDownloadApkModal, openDownloadApkIosModal, closeDownloadApkIosModal , openConfirmationModal, closeConfirmationModal, openNewLetterSuccessfullPopup , closeNewLetterSuccessfullPopup} = modalSlice.actions;

export default modalSlice.reducer;